define(["../gatewayModule",
        "json!../gateway.json"
    ],
    function (gatewayModule) {
        "use strict";

        return gatewayModule.controller("GatewayIntegrationController", [
            "$scope",
            "gatewayService",
            "configurations",
            "loadingService",
            "remoteExceptionHandler",
            "messagesModal",
            function ($scope, gatewayService, configurations, loadingService, remoteExceptionHandler, messagesModal) {

                $scope.integrationConfigurationTableOptions = {
                    columns: [{
                        header: "gateway.integration.config.permission.group.code",
                        cell: {
                            type: "singleTagInput",
                            model: "record.permissionGroup",
                            getTags: "getPermissionGroups()",
                            ngDisabled: "record.id || ngDisabled"
                        },
                        width: "30%",
                        cellName: "integrationConfigurationRegionSourceId"
                    }, {
                        header: "gateway.integration.config.permission.group.url",
                        cell: {
                            type: "text",
                            model: "record.integrationURL"
                        },
                        cellName: "integrationConfigurationRegionURL"
                    }, {
                        header: {
                            template: "<button name='add' class='btn btn-xs green' style='margin-left: 20px;' ng-click='add()' data-cy='addButton'><span class='fa fa-plus'></span></button>",
                            style: "text-align: center !important;"
                        },
                        cell: {
                            template: "<div class='text-center'><button name='save' class='btn btn-xs btn-primary' ng-click='save(record)' data-cy='saveButton' ng-disabled='shouldDisabled(record)'><span class='fa fa-save'></span></button> " +
                                "<button name='remove' ng-if='record.id' class='btn btn-xs red' ng-click='remove(record)' data-cy='removeButton'><span class='fa fa-trash'></span></button></div>"
                        },
                        width: "70px"
                    }]
                };
                $scope.integrationConfigurationTableOptions.records = configurations;

                $scope.add = function () {
                    $scope.integrationConfigurationTableOptions.records.unshift({});
                }

                $scope.getPermissionGroups = function () {
                    let selectedPermissionGroupIds = $scope.integrationConfigurationTableOptions.records.reduce((records, record) => {
                        let permissionGroupId = record.permissionGroup?.id;
                        if (permissionGroupId) {
                            records.push(permissionGroupId);
                        }
                        return records;
                    }, []);
                    return gatewayService.findPermissionGroups().then((permissionGroups) => {
                        return permissionGroups.filter((permissionGroup) => !selectedPermissionGroupIds.includes(permissionGroup.id));
                    }).catch(remoteExceptionHandler());
                }

                $scope.save = function (record) {
                    return loadingService(
                        gatewayService.saveConfiguration(record).then(() => {
                            return messagesModal("dialog.success", "gateway.integration.config.successSave").then(() =>
                                gatewayService.findConfigurations().then(function (permissionGroups) {
                                    $scope.integrationConfigurationTableOptions.records = permissionGroups;
                                }).catch(remoteExceptionHandler()))
                        }).catch(remoteExceptionHandler())
                    )
                };

                $scope.remove = function (record) {
                    return messagesModal.cancellable("dialog.proceed?", [{
                        keyBundle: "gateway.integration.configuration.remove.confimation"
                    }]).then(() => {
                        return loadingService(
                            gatewayService.removeConfiguration(record).then(() => {
                                return messagesModal("dialog.success", "gateway.integration.config.successDelete").then(() =>
                                    gatewayService.findConfigurations().then(function (configurations) {
                                        $scope.integrationConfigurationTableOptions.records = configurations;
                                    }).catch(remoteExceptionHandler()))
                            }).catch(remoteExceptionHandler())
                        )
                    })
                };

                $scope.shouldDisabled = function (record) {
                    return !!!(record.integrationURL && record.permissionGroup)
                }
            }]);
    });